import { render, staticRenderFns } from "./MainIndicatorView.vue?vue&type=template&id=2fda2789&scoped=true&"
import script from "./MainIndicatorView.vue?vue&type=script&lang=js&"
export * from "./MainIndicatorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda2789",
  null
  
)

export default component.exports